import React, { useEffect, useState } from 'react';
import {
    Alert,
    Box,
    Button,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField
} from '@mui/material';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { IconPlus, IconMapPin } from '@tabler/icons';
import api from '../../../../services/api';
import PageHeader from '../../../../../ui-component/extended/PageHeader';
import GlassCard from '../../../../../ui-component/extended/GlassCard';

const States = () => {
    const history = useHistory();
    const location = useLocation();
    const { countryId } = useParams();
    const [country] = useState(location.state?.country || null);

    const [appId, setAppId] = useState(null);
    const [states, setStates] = useState([]);
    const [status, setStatus] = useState({ type: '', message: '' });
    const [dialogOpen, setDialogOpen] = useState(false);
    const [form, setForm] = useState({ code: '', name: '' });

    useEffect(() => {
        (async () => {
            try {
                const res = await api.get('v1/apps/default/');
                setAppId(res.data.app.id);
            } catch (error) {
                console.error(error);
            }
        })();
    }, []);

    useEffect(() => {
        if (!appId) return;
        loadStates();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId]);

    const loadStates = async () => {
        try {
            const res = await api.get(`v1/apps/${appId}/states/?country=${countryId}`);
            setStates(res.data || []);
        } catch (error) {
            console.error(error);
            setStatus({ type: 'error', message: 'Erro ao carregar estados' });
        }
    };

    const handleSave = async () => {
        try {
            await api.post(`v1/apps/${appId}/states/`, { ...form, country: countryId });
            setDialogOpen(false);
            setForm({ code: '', name: '' });
            loadStates();
        } catch (error) {
            console.error(error);
            setStatus({ type: 'error', message: 'Erro ao criar estado' });
        }
    };

    return (
        <Box>
            <PageHeader
                icon={IconMapPin}
                gradient="teal"
                title={`Estados${country ? ` - ${country.name}` : ''}`}
                subtitle="Clique num estado para ver seus municípios"
                actions={
                    <Button variant="contained" startIcon={<IconPlus size={18} />} onClick={() => setDialogOpen(true)}>
                        Novo estado
                    </Button>
                }
            />

            {status.message && (
                <Alert severity={status.type} sx={{ mb: 2 }}>
                    {status.message}
                </Alert>
            )}

            <GlassCard>
                <CardContent>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>UF</TableCell>
                                <TableCell>Nome</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {states.map((state) => (
                                <TableRow
                                    key={state.id}
                                    hover
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => history.push(`/dashboard/config/references/geography/states/${state.id}/cities`, { state })}
                                >
                                    <TableCell>{state.code}</TableCell>
                                    <TableCell>{state.name}</TableCell>
                                </TableRow>
                            ))}
                            {states.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={2} align="center">
                                        Nenhum estado cadastrado ainda
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </CardContent>
            </GlassCard>

            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Novo estado</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 1 }}>
                        <TextField
                            label="UF"
                            fullWidth
                            value={form.code}
                            onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })}
                        />
                        <TextField label="Nome" fullWidth value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)}>Cancelar</Button>
                    <Button variant="contained" onClick={handleSave}>
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default States;
